module.exports = __webpack_public_path__ + "static/media/delete.e70f6e09.svg";